<template>
  <div>
    <button class="btn btn-success" @click="refresh">Refresh</button>
    <h1>Currently connected users</h1>
    <table class="table table-condensed table-striped">
      <thead>
        <th>Id</th>
        <th>Name</th>
        <th>Version</th>
        <th>Force Reload</th>
      </thead>
      <tbody>
        <tr v-for="user in connectedUsers" :key="user.key">
          <td>{{ user.connectionId }}</td>
          <td>{{ user.username }}</td>
          <td>{{ user.version }}</td>
          <td><button class="btn btn-danger btn-sm" @click="forcePageReload(user.connectionId)">Force page-reload</button></td>
        </tr>
      </tbody>
    </table>
    <h1>Logs</h1>
    <table class="table table-sm table-striped">
      <thead></thead>
      <tbody>
        <tr v-for="log in logs" :key="log.id">
          <td>{{ log.insertDate }}</td>
          <td>{{ log.logger }}</td>
          <td>{{ log.message }}</td>
          <td>{{ log.level }}</td>
          <td>{{ log.exception }}</td>
        </tr>
      </tbody>
    </table>
    <div v-for="log in logs" :key="log.id">{{ log.insertDate }}</div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { ConnectedUserInfo, LogClient, LogDto } from "@/apiclient/apiclient_generated";
  import axios from 'axios';
  import { WS_URL as ApiUrl } from '@/config';

  @Component({})
  export default class LogsComponent extends Vue {
    private logService: LogClient = new LogClient(ApiUrl, axios);
    private logs: LogDto[] = [];
    private connectedUsers: ConnectedUserInfo[] = [];
    private interval: any;

    async mounted() {
      await this.refresh();
      this.interval = setInterval(async () => {
        await this.refresh();
      }, 20000);
    }

    async refresh() {
      this.connectedUsers = await this.logService.getConnectedUsers();
      this.logs = await this.logService.get();
    }

    async forcePageReload(connectionId: string) {
      await this.$opstaskhub.sendForceReload(connectionId);
    }

    destroyed() {
      clearInterval(this.interval);
    }
  }
</script>

<style lang="scss" scoped>
  .board-card {
    background: whitesmoke;
    background-size: cover;
    border-left: solid 10px #357ebd;
    cursor: pointer;
    display: flex;
    border-radius: 5px;
    transition: all 0.2s;
    height: 90px;

    box-shadow: 0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 0 1px rgba(9, 30, 66, 0.08);

    &:hover {
      box-shadow: 0 8px 16px -2px rgba(9, 30, 66, 0.25), 0 0 0 1px rgba(9, 30, 66, 0.08);
      border-left: solid 20px #357ebd;
      text-decoration: none;
    }

    .board-card-image {
      width: 120px;
    }

    .board-card-title {
      color: #333;
      width: 160px;
      text-align: center;
      font-weight: bold;
      font-size: 1.3rem;
      text-decoration: none;
    }
  }
</style>
